import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Grupo Industrial Vanguardia",
    role: "Cliente corporativo",
    image:
      "https://images.pexels.com/photos/14585727/pexels-photo-14585727.jpeg",
    quote:
      "La auditoría técnica de Sagitta detectó áreas de riesgo que otros despachos ignoraron; su intervención fue vital para nuestra estabilidad financiera este 2025.",
  },
  {
    name: "Lic. Mauricio Valdés",
    role: "Inversionista",
    image:
      "https://images.unsplash.com/photo-1762522926157-bcc04bf0b10a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w8NjAzMjd8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdCUyMGhlYWRzaG90fGVufDB8fHx8MTc3OTI4NDU3MXww&ixlib=rb-4.1.0&q=85",
    quote:
      "Confío plenamente en la consultoría legal de Nobleza Sagitta; su capacidad para resolver trámites complejos en tiempo récord es simplemente inigualable aquí en Guadalajara.",
  },
  {
    name: "Dra. Elena Martínez",
    role: "Profesional independiente",
    image:
      "https://images.pexels.com/photos/14589344/pexels-photo-14589344.jpeg",
    quote:
      "Me ayudaron a regularizar mi situación contable con una paciencia y profesionalismo excepcionales; se siente la nobleza de su servicio desde la primera cita.",
  },
  {
    name: "Comercializadora Global S.A.",
    role: "Cliente corporativo",
    image:
      "https://images.unsplash.com/photo-1774850236254-f0aa024ca20c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBlbGVnYW50fGVufDB8fHx8MTc3OTMxNDEyN3ww&ixlib=rb-4.1.0&q=85",
    quote:
      "Su asesoría administrativa cambió nuestra forma de operar; ahora tenemos una estructura legal robusta que nos permite expandirnos sin temor a contingencias.",
  },
];

export default function Testimonios() {
  return (
    <section
      id="testimonios"
      data-testid="testimonials-section"
      className="relative py-24 lg:py-32 bg-[#FAFAFA]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="reveal eyebrow mb-5">Testimonios</div>
            <h2 className="reveal font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-neutral-950">
              La voz de quienes{" "}
              <span className="italic text-[#E97906]">confían</span> su
              trayectoria.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 reveal flex items-center gap-2">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                size={18}
                fill="#EDB900"
                stroke="#EDB900"
                className="shrink-0"
              />
            ))}
            <span className="ml-2 text-sm text-neutral-600">
              Confianza · Rectitud · Resultados
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <article
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="reveal relative bg-white border border-neutral-200 p-8 lg:p-10 hover:border-[#E97906] transition-colors duration-500 group"
            >
              <Quote
                size={36}
                className="text-[#E97906] opacity-90"
                strokeWidth={1.5}
              />
              <p className="mt-6 font-serif-display italic text-xl lg:text-[22px] leading-snug text-neutral-900">
                “{t.quote}”
              </p>

              <div className="mt-8 flex items-center gap-4 pt-6 border-t border-neutral-200">
                <div>
                  <div className="font-semibold text-neutral-950">
                    {t.name}
                  </div>
                  <div className="text-xs uppercase tracking-[0.22em] text-neutral-500 mt-0.5">
                    {t.role}
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
